/**
 * @generated SignedSource<<b1c5c4ed640749709506cf590f665703>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_user">;
  readonly " $fragmentType": "PdpRespSellerItemsCarousel_user";
};
export type PdpRespSellerItemsCarousel_user$key = {
  readonly " $data"?: PdpRespSellerItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "151219c3ae79ec7f52569066099c1d25";

export default node;
